import { render, staticRenderFns } from "./ProfessionalDataTable.vue?vue&type=template&id=be9f6214&scoped=true&"
import script from "./ProfessionalDataTable.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalDataTable.vue?vue&type=style&index=0&id=be9f6214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9f6214",
  null
  
)

export default component.exports